/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {RegistrationCode} from '../models/RegistrationCode';

export interface GetBrowserRegistrationCode$Request {
    userId: number;
}

export interface GetBrowserRegistrationCode$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getBrowserRegistrationCodeRequest = createAction<PayloadData<void, GetBrowserRegistrationCode$Request>>('GET_BROWSER_REGISTRATION_CODE__GET_BROWSER_REGISTRATION_CODE__REQUEST');
export const getBrowserRegistrationCodeSuccess = createAction<PayloadData<RegistrationCode, GetBrowserRegistrationCode$Request>>('GET_BROWSER_REGISTRATION_CODE__GET_BROWSER_REGISTRATION_CODE__SUCCESS');
export const getBrowserRegistrationCodeFailure = createAction<PayloadData<Error, GetBrowserRegistrationCode$Request, true>>('GET_BROWSER_REGISTRATION_CODE__GET_BROWSER_REGISTRATION_CODE__FAILURE');

export const getBrowserRegistrationCodeActions = [
    getBrowserRegistrationCodeRequest,
    getBrowserRegistrationCodeSuccess,
    getBrowserRegistrationCodeFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getBrowserRegistrationCode = (meta: GetBrowserRegistrationCode$Request, config?: GetBrowserRegistrationCode$Config) => {
    return {
        CALL_API: {
            types: getBrowserRegistrationCodeActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/browser-registration/retrieve`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

